(() => {
  const STORAGE_KEY = 'hw_trade_attribution';

  function safeRead(storage) {
    try {
      const parsed = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
      return {};
    }
  }

  function safeWrite(storage, value) {
    try {
      storage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch {
      // Attribution must never block the form.
    }
  }

  function buildAttribution(search, path, storage) {
    const existing = safeRead(storage);
    const params = new URLSearchParams(search);
    const attribution = {
      utm_source: existing.utm_source || params.get('utm_source') || '',
      utm_medium: existing.utm_medium || params.get('utm_medium') || '',
      utm_campaign: existing.utm_campaign || params.get('utm_campaign') || '',
      landing_page: existing.landing_page || path,
    };
    safeWrite(storage, attribution);
    return attribution;
  }

  function eventPayload(attribution, pagePath) {
    return {
      page_path: pagePath,
      landing_page: attribution.landing_page || '',
      utm_source: attribution.utm_source || '',
      utm_medium: attribution.utm_medium || '',
      utm_campaign: attribution.utm_campaign || '',
    };
  }

  function publish(name, payload) {
    try {
      window.Shopify?.analytics?.publish?.(name, payload);
    } catch {
      // Analytics must never block the form.
    }
  }

  function init() {
    const attribution = buildAttribution(
      window.location.search,
      `${window.location.pathname}${window.location.search}`,
      sessionStorage,
    );
    const form = document.querySelector('#TradeApplication');
    if (!form) return;
    const payload = eventPayload(attribution, window.location.pathname);

    form.querySelectorAll('[data-trade-attribution]').forEach((field) => {
      const key = field.dataset.tradeAttribution;
      field.value = key === 'submission_page' ? window.location.pathname : attribution[key] || '';
    });

    publish('trade_page_view', payload);
    form.addEventListener('input', () => publish('trade_form_start', payload), { once: true });
    form.addEventListener('submit', () => publish('trade_form_submit_attempt', payload));
    if (form.querySelector('[data-trade-form-success]')) publish('trade_form_success', payload);
  }

  window.HybridWorkshopTradeTracking = { buildAttribution, eventPayload, init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
